/* eslint-disable react-hooks/exhaustive-deps */

import React, { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import {
  Layout,
  Card,
  Row,
  Col,
  Statistic,
  Tag,
  Spin,
  Table,
  Collapse,
  Button,
  Divider,
  Space,
} from "antd";

import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  MinusOutlined,
  ReloadOutlined,
  RollbackOutlined,
} from "@ant-design/icons";

import { useParams } from "react-router-dom";

import dayjs from "dayjs";

import { getAPI } from "../../utils/common";

import { SMART_PRICE } from "../../constants/api";

function SmartPriceComparison() {
  const { Content } = Layout;
  const { room_id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  let navigate = useNavigate();

  useLayoutEffect(() => {
    getComparison();
  }, []);

  const getComparison = () => {
    setLoading(true);

    getAPI(
      SMART_PRICE + "/room/" + room_id + "/comparison",

      (res) => {
        if (res.status) {
          setData(res.data);
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },

      {},
    );
  };

  const historyColumns = [
    {
      title: "Old Price",

      dataIndex: "old_price",

      render: (v) => <Tag>₹ {v}</Tag>,
    },

    {
      title: "New Price",

      dataIndex: "new_price",

      render: (v) => <Tag color="green">₹ {v}</Tag>,
    },

    {
      title: "Type",

      dataIndex: "change_type",

      render: (v) => <Tag color="blue">{v}</Tag>,
    },

    {
      title: "Reason",

      dataIndex: "reason",

      render: (v) => {
        try {
          let reasons = JSON.parse(v);

          return (
            <Collapse
              items={[
                {
                  key: "1",

                  label: "View AI Reason",

                  children: reasons.map((item, index) => (
                    <div key={index}>
                      <Tag color="purple">{item.factor}</Tag>

                      <b>{item.action}</b>

                      <br />

                      {item.reason}

                      <Divider />
                    </div>
                  )),
                },
              ]}
            />
          );
        } catch {
          return v || "-";
        }
      },
    },

    {
      title: "Date",

      dataIndex: "effective_date",

      render: (v) => dayjs(v).format("DD MMM YYYY"),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Smart Price Comparison"
          extra={
            <Space>
              <Button icon={<ReloadOutlined />} onClick={getComparison}>
                Refresh
              </Button>
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            </Space>
          }
        >
          <Spin spinning={loading}>
            {data && (
              <>
                {/* Room Info */}

                <Card title="Room Information">
                  <Row gutter={20}>
                    <Col span={8}>
                      <Statistic title="Room Name" value={data.room?.name} />

                      <Tag>{data.room?.room_no}</Tag>
                    </Col>

                    <Col span={8}>
                      <Statistic
                        title="Base Price"
                        value={data.room?.base_price}
                        prefix="₹"
                      />
                    </Col>

                    <Col span={8}>
                      <Statistic
                        title="Current Status"
                        value={data.pricing?.status}
                      />
                    </Col>
                  </Row>
                </Card>

                <br />

                {/* Price Comparison */}

                <Card title="Price Recommendation">
                  <Row gutter={20}>
                    <Col span={6}>
                      <Statistic
                        title="Current Price"
                        value={data.pricing?.current_price}
                        prefix="₹"
                      />
                    </Col>

                    <Col span={6}>
                      <Statistic
                        title="Suggested Price"
                        value={data.pricing?.suggested_price}
                        prefix="₹"
                        valueStyle={{
                          color:
                            data.pricing?.direction === "increase"
                              ? "green"
                              : data.pricing?.direction === "decrease"
                                ? "red"
                                : "orange",
                        }}
                      />
                    </Col>

                    <Col span={6}>
                      <Statistic
                        title="Difference"
                        value={data.pricing?.difference}
                        prefix="₹"
                      />
                    </Col>

                    <Col span={6}>
                      <Statistic
                        title="Change %"
                        value={data.pricing?.change_percentage}
                        suffix="%"
                      />
                    </Col>
                  </Row>

                  <br />

                  {data.pricing?.direction === "increase" && (
                    <Tag color="green" icon={<ArrowUpOutlined />}>
                      Increase Price
                    </Tag>
                  )}

                  {data.pricing?.direction === "decrease" && (
                    <Tag color="red" icon={<ArrowDownOutlined />}>
                      Decrease Price
                    </Tag>
                  )}

                  {data.pricing?.direction === "maintain" && (
                    <Tag color="orange" icon={<MinusOutlined />}>
                      Maintain Price
                    </Tag>
                  )}
                </Card>
                {data.pricing?.status === "rejected" &&
                  data.pricing?.rejected_reason && (
                    <Card
                      style={{
                        marginTop: 20,
                        background: "#fff1f0",
                        borderColor: "#ffccc7",
                      }}
                    >
                      <Tag color="red">Rejected</Tag>

                      <p style={{ marginTop: 10 }}>
                        <b>Reason:</b> {data.pricing.rejected_reason}
                      </p>
                    </Card>
                  )}

                <br />

                {/* AI Analysis */}

                <Card title="AI Analysis">
                  <Row gutter={20}>
                    <Col span={6}>
                      <Statistic
                        title="AI Score"
                        value={data.ai_analysis?.score}
                      />
                    </Col>

                    <Col span={6}>
                      <Statistic
                        title="Demand Level"
                        value={data.ai_analysis?.demand_level}
                      />
                    </Col>

                    <Col span={12}>
                      <Tag>
                        Generated:{" "}
                        {dayjs(data.validity?.generated_date).format(
                          "DD MMM YYYY",
                        )}
                      </Tag>

                      <Tag color="red">
                        Valid Till:{" "}
                        {dayjs(data.validity?.valid_until).format(
                          "DD MMM YYYY HH:mm",
                        )}
                      </Tag>
                    </Col>
                  </Row>

                  <br />

                  <Collapse
                    items={[
                      {
                        key: "1",

                        label: "View AI Signals",

                        children: data.ai_analysis?.signals?.map(
                          (item, index) => (
                            <div key={index}>
                              <Tag color="purple">{item.factor}</Tag>

                              <Tag>Score {item.score}</Tag>

                              <b>{item.action}</b>

                              <p>{item.reason}</p>

                              <Divider />
                            </div>
                          ),
                        ),
                      },
                    ]}
                  />
                </Card>

                <br />

                {/* History */}

                <Card title="Price Change History">
                  <Table
                    columns={historyColumns}
                    dataSource={data.history || []}
                    rowKey={(row, index) => index}
                    pagination={false}
                    scroll={{
                      x: 1000,
                    }}
                  />
                </Card>
              </>
            )}
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default SmartPriceComparison;
